import React, { useState, forwardRef, useEffect } from "react";
import {
  Paper,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";

// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from "date-fns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers";
import { getFollowUpEventList } from "../../../api/calender";
import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../../config/action-config";

const tempEvents = [{ title: "", start: "", id: 0 }];

export default function FollowupCalender() {
  const [eventDialogOpen, setEventDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState("CREATE");
  const [selectedEvent, setSelectedEvent] = useState(0);
  const [events, setEvents] = useState(tempEvents);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const onAddEventClick = () => {
    setDialogMode("CREATE");
    setEventDialogOpen(true);
  };

  const onCalendarEventClick = ({ event }) => {
    setSelectedEvent(allowedEventData(event));
    setDialogMode("EDIT");
    setEventDialogOpen(true);
  };

  async function onEventAdd(data) {
    try {
      // api call here
      setEvents((prev) => [...prev, data]);
      setEventDialogOpen(false);
    } catch (error) {}
  }

  async function onEventUpdate(id, data) {
    try {
      // api call
      setEvents((prev) =>
        prev.map((e) => {
          if (e.id == id) return data;
          return e;
        })
      );
      setEventDialogOpen(false);
    } catch (error) {}
  }

  async function onEventDelete(id) {
    try {
      // api call here
      setEvents((prev) => prev.filter((e) => e.id != id));
      setEventDialogOpen(false);
    } catch (error) {}
  }
  useEffect(() => {
    if (!user.token) return;
    // setLoading(true);
    getFollowUpEventList(user.token)
      .then(({ data }) => {
        // let events = praseEvents(data.data)

        const mapData = data.records.map((event) => ({
          id: event.follow_id,
          start: convertDate(event.follow_date),
          end: convertDate(event.follow_date),
          title: event.description,
        }));

        setEvents(mapData);
      })
      .catch((error) => {
        handleAxiosError(error, dispatch);
      })
      .finally(() => {
        // setLoading(false);
      });
  }, [user.token]);

  return (
    <>
      <Box mb={2} display="flex" justifyContent="flex-end">
        {/* <Button variant="contained" size="small" onClick={onAddEventClick}>
          Add Event
        </Button> */}
      </Box>
      <Paper elevation={4} sx={{ p: 2, width: "100%" }}>
        <FullCalendar
          defaultView="dayGridMonth"
          header={{
            left: "prev,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          plugins={[dayGridPlugin, timeGridPlugin]}
          events={events}
          eventClick={onCalendarEventClick}
        />
      </Paper>
      <EventDialog
        open={eventDialogOpen}
        setOpen={setEventDialogOpen}
        onEventAdd={onEventAdd}
        mode={dialogMode}
        onEventUpdate={onEventUpdate}
        onEventDelete={onEventDelete}
        selectedEvent={selectedEvent}
      />
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const emptyEventData = {
  title: "",
  start: "",
  end: "",
};

function EventDialog({
  open,
  setOpen,
  onEventAdd,
  mode,
  selectedEvent,
  onEventUpdate,
  onEventDelete,
}) {
  const [data, setData] = useState(emptyEventData);

  const handleDataChange = ({ target }) => {
    setData((prev) => ({ ...prev, [target.name]: target.value }));
  };

  useEffect(() => {
    if (mode === "CREATE") {
      setData(emptyEventData);
    } else {
      setData(selectedEvent);
    }
  }, [mode, open]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleEventSubmit = (e) => {
    e.preventDefault();
    if (mode === "CREATE") onEventAdd(data);
    else onEventUpdate(data.id, allowedEventData(data));
  };

  const handleEventDelete = () => {
    onEventDelete(data.id);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <Box component="form" onSubmit={handleEventSubmit}>
        <DialogTitle>{mode === "CREATE" ? "Add" : "Edit"} Event</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} pt={1}>
            <Grid item md={12} sm={12} xl={12}>
              <TextField
                label="Title"
                name="title"
                value={data.title}
                onChange={handleDataChange}
                size="small"
                fullWidth
                required
              />
            </Grid>
            {/* <Grid item md={12} sm={12} xl={12}>
                            <TextField label="Link (Optional)" name="url" value={data.url}
                                onChange={handleDataChange} size="small" fullWidth
                            />
                        </Grid> */}
            <Grid item md={12} sm={12} xl={12}>
              <FormControlLabel
                label="All Day Event"
                name="allDay"
                control={
                  <Checkbox
                    onChange={() => {
                      handleDataChange({
                        target: { name: "allDay", value: !data.allDay },
                      });
                    }}
                  />
                }
                checked={data.allDay}
              />
            </Grid>
            {data.allDay ? (
              <>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Start Date"
                      required
                      minDateTime={parseISO(new Date().toISOString())}
                      value={parseISO(data.start)}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "start",
                            value: new Date(newValue).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="End Date"
                      minDateTime={parseISO(
                        data.start || new Date().toISOString()
                      )}
                      value={parseISO(data.end || new Date().toISOString())}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "end",
                            value: new Date(newValue).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                          helperText="Ignore if one day event only"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      label="Start At"
                      required
                      minDateTime={parseISO(new Date().toISOString())}
                      value={parseISO(data.start || new Date().toISOString())}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "start",
                            value: new Date(newValue).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={6} xl={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      label="End At"
                      required
                      minDateTime={parseISO(
                        data.start || new Date().toISOString()
                      )}
                      value={parseISO(data.end || new Date().toISOString())}
                      onChange={(newValue) => {
                        handleDataChange({
                          target: {
                            name: "end",
                            value: new Date(newValue).toISOString(),
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          fullWidth
                          size="small"
                          variant="outlined"
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="secondary" className="cancel-button">
            Cancel
          </Button>
          <Button variant="contained" type="submit">
            {mode === "CREATE" ? "Add" : "Edit"}
          </Button>
          {mode === "EDIT" ? (
            <Button
              variant="contained"
              color="error"
              onClick={handleEventDelete}
              className="blue-button"
            >
              Delete
            </Button>
          ) : (
            <></>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
}

function allowedEventData(data) {
  return {
    id: data.id,
    title: data.title,
    allDay: data.allDay,
    start: new Date(data.start).toISOString(),
    end: new Date(data.end).toISOString(),
    url: data.url,
  };
}

function getDate(dayString) {
  const today = new Date();
  const year = today.getFullYear().toString();
  let month = (today.getMonth() + 1).toString();

  if (month.length === 1) {
    month = "0" + month;
  }

  return dayString.replace("YEAR", year).replace("MONTH", month);
}

const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];
function convertDate(date) {
  const [month, day, year] = date.split("-");
  const convertedMonth = String(months.indexOf(month) + 1).padStart(2, "0");
  return `${year}-${convertedMonth}-${day}`;
}
